import cx from 'classnames'

interface BannerProps {
  type?: 'info' | 'success' | 'error'
  icon: React.ReactChild
  text: string
  heading?: string
  cta?: React.ReactNode
  altColor?: boolean
  onClick?: React.MouseEventHandler<HTMLDivElement>
  className?: string
}

const PhraseeBanner = (props: BannerProps) => {
  const { icon, text, cta, onClick, heading, altColor, type, className } = props

  return (
    <div
      onClick={onClick}
      className={cx(
        'flex items-center px-6 py-3 rounded-sm',
        {
          'cursor-pointer': onClick,
          'text-amber-700': altColor,
          'border border-black bg-white text-base-700': type === 'info',
          'bg-RAGGreen text-white': type === 'success',
          'bg-RAGred text-white': type === 'error',
        },
        className
      )}
    >
      <span className="mr-2">{icon}</span>
      <div className="flex-row">
        <div className="flex-1">
          {heading && (
            <span
              className={`${cx('text-base font-normal', {
                'text-amber-700': altColor,
              })}`}
            >
              {heading}
            </span>
          )}
        </div>
        <div className="flex-1">
          <span
            className={`${cx('text-base font-normal', {
              'text-amber-700': altColor,
            })}`}
          >
            {text}
          </span>
        </div>
      </div>
      <div className="flex-1 flex-row text-right">
        <div className="flex items-center text-base font-normal self-end justify-end">
          {cta}
        </div>
      </div>
    </div>
  )
}

export default PhraseeBanner
